export const colors = {
    "porsche" : [
        { "hex": "#B5D3D7", "name": "Adria Blue" },
        { "hex": "#236CF2", "name": "Adriatic Blue" },
        { "hex": "#74A1AD", "name": "Aetna Blue (Etna Blue)" },
        { "hex": "#16374E", "name": "Aga Blue" },
        { "hex": "#13657D", "name": "Alaska Blue" },
        { "hex": "#0D3872", "name": "Albert Blue" },
        { "hex": "#4673E5", "name": "Ancona Blue" },
        { "hex": "#093DB4", "name": "Aqua Blue" },
        { "hex": "#2D5A80", "name": "Aquamarine Blue" },
        { "hex": "#389ED9", "name": "Arrow Blue" },
        { "hex": "#373C86", "name": "Ascari Blue" },
        { "hex": "#1B3A73", "name": "Azure Blue" },
        { "hex": "#0B1D33", "name": "Azurite Blue" },
        { "hex": "#A2BACF", "name": "Azurro California" },
        { "hex": "#9DC6D9", "name": "Azzurrothetys" },
        { "hex": "#105CCE", "name": "Bahama Blue" },
        { "hex": "#073779", "name": "Bali Blue" },
        { "hex": "#41648A", "name": "Baltic Blue" },
        { "hex": "#92BFC3", "name": "Biscay Blue" },
        { "hex": "#2B66A3", "name": "Blue" },
        { "hex": "#2BA4F1", "name": "Blue Turquoise" },
        { "hex": "#0075E1", "name": "Club Blau" },
        { "hex": "#114A97", "name": "Cobalt Blue" },
        { "hex": "#38587D", "name": "Copenhagen Blue" },
        { "hex": "#B4E2F7", "name": "Coppa Florio Blue" },
        { "hex": "#A6E9EF", "name": "Crystal Blue" },
        { "hex": "#212188", "name": "Dalmatian Blue (Oxford Blue)" },
        { "hex": "#143754", "name": "Dark Blue" },
        { "hex": "#160E5E", "name": "Dark Sapphire" },
        { "hex": "#111537", "name": "Dark Sea Blue" },
        { "hex": "#234469", "name": "Deep Blue" },
        { "hex": "#DFE1F1", "name": "Diamond Blue" },
        { "hex": "#30486C", "name": "Dove Blue" },
        { "hex": "#2567AB", "name": "Eisblau" },
        { "hex": "#3895D0", "name": "Estoril Blue" },
        { "hex": "#CED6FB", "name": "Fountain Blue" },
        { "hex": "#A5C5D9", "name": "Frozen Blue" },
        { "hex": "#507EBD", "name": "Gemini Blue" },
        { "hex": "#4B70AC", "name": "Gemini" },
        { "hex": "#1A3C91", "name": "Gentian Blue" },
        { "hex": "#4EBDF1", "name": "Glacier Blue (Dark)" },
        { "hex": "#E4F0EF", "name": "Glacier Blue (Light)" },
        { "hex": "#C5D9DD", "name": "Glacier" },
        { "hex": "#434BA9", "name": "Golf Blue" },
        { "hex": "#3E586A", "name": "Graphite Blue" },
        { "hex": "#1A65BA", "name": "Gulf Blue (Dark)" },
        { "hex": "#96D0E5", "name": "Gulf Blue (Light)" },
        { "hex": "#2B3959", "name": "Aero Blue" },
        { "hex": "#37346D", "name": "Azure Blue" },
        { "hex": "#A4B7CB", "name": "Bermuda Blue" },
        { "hex": "#517CBD", "name": "Blue Water" },
        { "hex": "#262E73", "name": "Dark Night Blue" },
        { "hex": "#2A5589", "name": "Kosmos Blue" },
        { "hex": "#B8FEFF", "name": "Light Blue" },
        { "hex": "#54B7D7", "name": "Liquid Blue" },
        { "hex": "#659FDB", "name": "Oxygen Blue" },
        { "hex": "#53A1D3", "name": "Sail Blue" },
        { "hex": "#080B30", "name": "Satin Blue" },
        { "hex": "#3B3074", "name": "Sepang Blue" },
        { "hex": "#46556D", "name": "Steel Blue" },
        { "hex": "#4F5570", "name": "Utopia Blue" },
        { "hex": "#CDD8DB", "name": "Vapor Blue" },
        { "hex": "#87B2E8", "name": "Horizon Blue" },
        { "hex": "#A8C3DA", "name": "Ice Blue" },
        { "hex": "#16ADC8", "name": "Ipanema Blue" },
        { "hex": "#9BBACC", "name": "Iris Blue" },
        { "hex": "#7DCDE7", "name": "Laguna Blue" },
        { "hex": "#091D66", "name": "Lapis Blue" },
        { "hex": "#9DC0CC", "name": "Light Blue" },
        { "hex": "#2B29A5", "name": "Manaus Blue" },
        { "hex": "#AAC2C7", "name": "Marathon Blue" },
        { "hex": "#4C5167", "name": "Marine Blue" },
        { "hex": "#4B77EA", "name": "Maritime Blue" },
        { "hex": "#2D488C", "name": "Mauritius Blue" },
        { "hex": "#BFD7E2", "name": "Meissen Blue" },
        { "hex": "#3DBDED", "name": "Mexico Blue" },
        { "hex": "#1BBFE8", "name": "Miami Blue" },
        { "hex": "#0B0553", "name": "Midnight Blue" },
        { "hex": "#1383DA", "name": "Minerva Blue" },
        { "hex": "#5781BA", "name": "Monaco Blue" },
        { "hex": "#282A47", "name": "Moonlight Blue" },
        { "hex": "#16335B", "name": "Nautic (Ocean) Blue" },
        { "hex": "#158ADB", "name": "Neptune Blue" },
        { "hex": "#0B3753", "name": "Night Blue" },
        { "hex": "#3649A7", "name": "Nogaro Blue" },
        { "hex": "#345970", "name": "Ocean Blue (Early)" },
        { "hex": "#142276", "name": "Ocean Blue" },
        { "hex": "#64CAF5", "name": "Olympic Blue" },
        { "hex": "#2E7FC3", "name": "Oslo Blue" },
        { "hex": "#375975", "name": "Pacific Blue" },
        { "hex": "#4DB3ED", "name": "Pastel Blue" },
        { "hex": "#0F647D", "name": "Petrol Blue" },
        { "hex": "#ACC1C9", "name": "Polar Blue" },
        { "hex": "#112A57", "name": "Prussian Blue" },
        { "hex": "#104EAA", "name": "Pure Blue" },
        { "hex": "#359BD0", "name": "Riviera Blue" },
        { "hex": "#0C5E98", "name": "Royal Blue" },
        { "hex": "#2B01B4", "name": "San Marino Blue" },
        { "hex": "#092F85", "name": "Sapphire Blue" },
        { "hex": "#0050AA", "name": "Shark Blue" },
        { "hex": "#4297C8", "name": "Sky Blue" },
        { "hex": "#70849F", "name": "Slate Blue" },
        { "hex": "#1168B3", "name": "Speedster Blue" },
        { "hex": "#2A87C8", "name": "Tahoe Blue" },
        { "hex": "#2146B1", "name": "Teal Blue" },
        { "hex": "#72C7CE", "name": "Turquoise" },
        { "hex": "#0A6EF5", "name": "Turquoise Blue" },
        { "hex": "#296D9C", "name": "Ultra Blue" },
        { "hex": "#054468", "name": "Venetian Blue" },
        { "hex": "#8A9FAA", "name": "Venice Blue" },
        { "hex": "#2982E0", "name": "Voodoo Blue" },
        { "hex": "#245E8A", "name": "Yachting Blue" },
        { "hex": "#565DB0", "name": "Zenith Blue" },
        { "hex": "#D1BCA8", "name": "Almond Beige" },
        { "hex": "#F0DCC9", "name": "Apricot Beige" },
        { "hex": "#F8E1B2", "name": "Bamboo Beige" },
        { "hex": "#D6CCBB", "name": "Bamboo" },
        { "hex": "#DEDECC", "name": "Beige Grey" },
        { "hex": "#E9C871", "name": "Beige" },
        { "hex": "#DDBA6F", "name": "Casablanca Beige" },
        { "hex": "#D29C5C", "name": "Cashmere Beige" },
        { "hex": "#DEB28A", "name": "Ceramic (Caramel) Beige" },
        { "hex": "#E6DAD1", "name": "Coffee Beige" },
        { "hex": "#F4ECAB", "name": "Desert Beige" },
        { "hex": "#D8CEAD", "name": "Gazelle" },
        { "hex": "#E9E8C2", "name": "Hellelfenbein" },
        { "hex": "#AD9A7B", "name": "Jarama Beige" },
        { "hex": "#D5D4B6", "name": "Kalahari Beige" },
        { "hex": "#7B694C", "name": "Luxor Beige" },
        { "hex": "#E8D3AB", "name": "Mexico Beige" },
        { "hex": "#FAF6EB", "name": "Pastel Beige" },
        { "hex": "#D6B2B2", "name": "Pongee Beige" },
        { "hex": "#FEEAAC", "name": "Sahara Beige" },
        { "hex": "#D8C193", "name": "Sand Beige" },
        { "hex": "#A2A590", "name": "Urban Bamboo ChromaFlair" },
        { "hex": "#a9885c", "name": "Byzantine Gold" },
        { "hex": "#E1DDC7", "name": "Flamingo" },
        { "hex": "#C3BE8F", "name": "Gold Bronze" },
        { "hex": "#E5AC00", "name": "Gold" },
        { "hex": "#D1D1B9", "name": "Hellbronze" },
        { "hex": "#DCF1B7", "name": "Lido Gold" },
        { "hex": "#DCD5B7", "name": "Light Bronze" },
        { "hex": "#E1E8B4", "name": "Lime Gold" },
        { "hex": "#D98A1A", "name": "Maya Gold" },
        { "hex": "#CFC6B8", "name": "Mirage" },
        { "hex": "#EB8B0F", "name": "Nordic Gold" },
        { "hex": "#C2B378", "name": "Opal" },
        { "hex": "#E0CFB3", "name": "Palladium" },
        { "hex": "#838272", "name": "Platinum" },
        { "hex": "#D7D9D0", "name": "Prosecco" },
        { "hex": "#CDCAC0", "name": "White Gold" },
        { "hex": "#322E2C", "name": "Anthracite Brown" },
        { "hex": "#A3580D", "name": "Bitter Chocolate (Cockney Brown)" },
        { "hex": "#5C4836", "name": "Brown" },
        { "hex": "#D6925B", "name": "Caramel Brown" },
        { "hex": "#474133", "name": "Chestnut Brown" },
        { "hex": "#261105", "name": "Chocolate Brown" },
        { "hex": "#412810", "name": "Coffee (Cocoa) Brown" },
        { "hex": "#824C20", "name": "Cognac Brown" },
        { "hex": "#C3926E", "name": "Cognac" },
        { "hex": "#BBAB99", "name": "Copper Bronze" },
        { "hex": "#DB8B5F", "name": "Coral" },
        { "hex": "#2F2214", "name": "Espresso Brown" },
        { "hex": "#3D2A24", "name": "Macadamia" },
        { "hex": "#512F0F", "name": "Mahogany Brown" },
        { "hex": "#3C0606", "name": "Mahogany" },
        { "hex": "#331E12", "name": "Mocha Brown" },
        { "hex": "#BF9570", "name": "Nougat Brown" },
        { "hex": "#61330B", "name": "Nutmeg Brown" },
        { "hex": "#A1523D", "name": "Red Brown" },
        { "hex": "#5D5650", "name": "Ristretto Brown" },
        { "hex": "#694E4E", "name": "Rosewood (Palisander)" },
        { "hex": "#534138", "name": "Sable Brown" },
        { "hex": "#905508", "name": "Sepia Brown" },
        { "hex": "#DFA687", "name": "Terra Cotta" },
        { "hex": "#816F43", "name": "Tobacco" },
        { "hex": "#3C1F0C", "name": "Togo Brown" },
        { "hex": "#E6DCC4", "name": "Topaz Brown" },
        { "hex": "#5A341A", "name": "Truffle Brown" },
        { "hex": "#9D8573", "name": "Umbra" },
        { "hex": "#764283", "name": "Amaranth Violet" },
        { "hex": "#56032E", "name": "Amethyst" },
        { "hex": "#66093E", "name": "Aubergine" },
        { "hex": "#430C25", "name": "Aubergine" },
        { "hex": "#F6D8F4", "name": "Frozen Berry" },
        { "hex": "#DA5486", "name": "Magenta" },
        { "hex": "#543B67", "name": "Merlin Purple" },
        { "hex": "#E9E0EA", "name": "Moonstone (Lilac)" },
        { "hex": "#F999DB", "name": "Pink Pig" },
        { "hex": "#5A355F", "name": "Purple Violet" },
        { "hex": "#6B1FE0", "name": "Purpurite" },
        { "hex": "#20036B", "name": "Purpurit" },
        { "hex": "#AB3F59", "name": "Raspberry Red" },
        { "hex": "#5D3F6C", "name": "Royal Purple (Lilac)" },
        { "hex": "#c90d7b", "name": "Ruby Star Neo" },
        { "hex": "#D70769", "name": "Rubystar" },
        { "hex": "#CD2761", "name": "Rubystone Red (Ruby Star)" },
        { "hex": "#62416B", "name": "Ultraviolet" },
        { "hex": "#482480", "name": "Velvet Purple" },
        { "hex": "#554351", "name": "Vesuvio" },
        { "hex": "#6335C6", "name": "Viola Purple" },
        { "hex": "#A478C6", "name": "Violet Blue" },
        { "hex": "#120313", "name": "Violet Chromaflair" },
        { "hex": "#BCBCBC", "name": "964 Polar Silver" },
        { "hex": "#5A5A5A", "name": "Agate Grey" },
        { "hex": "#B2B2B2", "name": "Alex Grey" },
        { "hex": "#5F5B5B", "name": "Anthracite" },
        { "hex": "#676464", "name": "Arctic Grey" },
        { "hex": "#E3E3E3", "name": "Arrow Grey" },
        { "hex": "#535353", "name": "Atlas Grey" },
        { "hex": "#6F6D69", "name": "Carbon Grey" },
        { "hex": "#5F5F62", "name": "Carbon Steel Grey" },
        { "hex": "#E1DEDE", "name": "Chalk" },
        { "hex": "#BDBDBD", "name": "China Grey" },
        { "hex": "#4C4136", "name": "Dolomite Grey" },
        { "hex": "#E1EAE8", "name": "Dolphin Gray" },
        { "hex": "#E3E9EB", "name": "Dolphin Grey" },
        { "hex": "#CDD0D1", "name": "Fashion Gray" },
        { "hex": "#C8C8C8", "name": "Fish Silver Grey" },
        { "hex": "#E9E9E5", "name": "Gabon Grey" },
        { "hex": "#9AA3A9", "name": "Gemini Grey" },
        { "hex": "#D7D4C8", "name": "Geyser Grey" },
        { "hex": "#454341", "name": "Graphite Grey" },
        { "hex": "#BEBEBE", "name": "Graphite" },
        { "hex": "#464242", "name": "Grey Black" },
        { "hex": "#D0D0D0", "name": "Grigio Campovolo" },
        { "hex": "#BDBDBD", "name": "Grigio Granito" },
        { "hex": "#C7C7D2", "name": "Grigio Telesto" },
        { "hex": "#E9E9E4", "name": "Heron Grey" },
        { "hex": "#D9D9D9", "name": "Ice Grey" },
        { "hex": "#413838", "name": "Lava Grey" },
        { "hex": "#DBDAC7", "name": "Linen Grey" },
        { "hex": "#F3F3D7", "name": "Linen" },
        { "hex": "#E6E6E3", "name": "Marble Grey" },
        { "hex": "#9C9C9C", "name": "Medium Grey" },
        { "hex": "#2D2D2D", "name": "Meteor Grey" },
        { "hex": "#2D2B2B", "name": "Meteor" },
        { "hex": "#BFBEBE", "name": "Nardo Grey" },
        { "hex": "#C8C7CD", "name": "Nimbus Grey" },
        { "hex": "#E3E4E9", "name": "Pearl Grey" },
        { "hex": "#5D5D58", "name": "Quartz Grey" },
        { "hex": "#879586", "name": "Quartzite Grey" },
        { "hex": "#DEDEDD", "name": "Sand Grey" },
        { "hex": "#BEBEBE", "name": "Sapphire" },
        { "hex": "#A6C3CD", "name": "Schiefer" },
        { "hex": "#474343", "name": "Seal Grey" },
        { "hex": "#707070", "name": "Slate Grey" },
        { "hex": "#707070", "name": "Slate Grey" },
        { "hex": "#DAE1E1", "name": "Sports Classic Grey" },
        { "hex": "#C2BE81", "name": "Stone Grey" },
        { "hex": "#A0A0A0", "name": "Terra Grey" },
        { "hex": "#6A6161", "name": "Titan" },
        { "hex": "#504F4F", "name": "Titanium" },
        { "hex": "#CECCCC", "name": "Umbra" },
        { "hex": "#6E6C65", "name": "Vesuvius Grey" },
        { "hex": "#444343", "name": "Volcano Grey" },
        { "hex": "#E1E1E1", "name": "Arctic Silver" },
        { "hex": "#DEDCDA", "name": "Aztec Silver" },
        { "hex": "#ECE9E9", "name": "Classic Silver" },
        { "hex": "#E6E8E8", "name": "Crystal Silver" },
        { "hex": "#D3D3D3", "name": "Diamond Silver" },
        { "hex": "#F9F9FC", "name": "Dolomite Silver" },
        { "hex": "#AABECF", "name": "Fish Silver Grey" },
        { "hex": "#EFF0F0", "name": "GT Silver" },
        { "hex": "#C6C2B4", "name": "Meridian" },
        { "hex": "#D3D6D7", "name": "Pewter" },
        { "hex": "#AFAFA2", "name": "Platinum Silver" },
        { "hex": "#CCCCCC", "name": "Polar Silver" },
        { "hex": "#EAE8E8", "name": "Rhodium Silver" },
        { "hex": "#F1F1F1", "name": "Silver" },
        { "hex": "#F6E7E7", "name": "Silver Rose" },
        { "hex": "#E5E5E5", "name": "Tin (Zinc)" },
        { "hex": "#DBDBDB", "name": "Titanium Silver" },
        { "hex": "#F4F8F4", "name": "Zermatt Silver" },
        { "hex": "#BC220D", "name": "Amaranth Red" },
        { "hex": "#7C0B26", "name": "Arena Red" },
        { "hex": "#7B1010", "name": "Auburn" },
        { "hex": "#E50000", "name": "Bahia Red" },
        { "hex": "#550808", "name": "Brocade Red" },
        { "hex": "#372C26", "name": "Burgundy Pearl" },
        { "hex": "#650712", "name": "Burgundy Red" },
        { "hex": "#940000", "name": "Carmine Red" },
        { "hex": "#CAAEB6", "name": "Cassis Red" },
        { "hex": "#370620", "name": "Cherry Red" },
        { "hex": "#E04C1E", "name": "Copper Ruby" },
        { "hex": "#E93535", "name": "Coral Red" },
        { "hex": "#940B0B", "name": "Fire Red" },
        { "hex": "#9A171A", "name": "Gambia Red" },
        { "hex": "#AA0000", "name": "GTS Red" },
        { "hex": "#FF0000", "name": "Guards Red" },
        { "hex": "#C41F1F", "name": "Impulse Red" },
        { "hex": "#B74646", "name": "Indiana Red" },
        { "hex": "#C03B25", "name": "Kiln Red" },
        { "hex": "#AA0808", "name": "Malaga Red" },
        { "hex": "#9C0000", "name": "Malvern Red" },
        { "hex": "#6A2727", "name": "Maraschino Red" },
        { "hex": "#721616", "name": "Maroon" },
        { "hex": "#F22F2F", "name": "Mars Red" },
        { "hex": "#B54527", "name": "Dark Red" },
        { "hex": "#AD2C2C", "name": "Orient Red" },
        { "hex": "#501111", "name": "Pascha Red" },
        { "hex": "#B0301F", "name": "Peru Red" },
        { "hex": "#F63C18", "name": "Phoenix Red" },
        { "hex": "#F72D2D", "name": "Polo Red" },
        { "hex": "#8B0F0F", "name": "Polyantha Red" },
        { "hex": "#C81111", "name": "Pure Red" },
        { "hex": "#A61F1F", "name": "Racing Red" },
        { "hex": "#D11111", "name": "Red" },
        { "hex": "#F12651", "name": "Rose Red" },
        { "hex": "#E12C2C", "name": "Rosso Scuderia" },
        { "hex": "#4C1212", "name": "Cherry Blossom" },
        { "hex": "#9B3346", "name": "Rubin Red" },
        { "hex": "#C12020", "name": "Ruby Red" },
        { "hex": "#AB2A2A", "name": "Ruby Red" },
        { "hex": "#E12F1D", "name": "Scarlet Red" },
        { "hex": "#D6432B", "name": "Sienna" },
        { "hex": "#761A02", "name": "Sienna Red" },
        { "hex": "#F21717", "name": "Signal Red" },
        { "hex": "#E40808", "name": "Strawberry Red" },
        { "hex": "#1E0303", "name": "Superior Red" },
        { "hex": "#961212", "name": "Surinam Red" },
        { "hex": "#B80D0D", "name": "Turkish Red" },
        { "hex": "#CA1642", "name": "Velvet Red" },
        { "hex": "#C02E16", "name": "Wine Red" },
        { "hex": "#D9401C", "name": "Zanzibar Red" },
        { "hex": "#E74B0E", "name": "Absolute Red" },
        { "hex": "#D12F2F", "name": "Amulet Red" },
        { "hex": "#761212", "name": "Indiana Red" },
        { "hex": "#ED1A1A", "name": "Light Red" },
        { "hex": "#DD3E46", "name": "Red Matte" },
        { "hex": "#BE4C14", "name": "Sepia Brown Red" },
        { "hex": "#A83A1C", "name": "Storm Red" },
        { "hex": "#BF3B29", "name": "Valent Red" },
        { "hex": "#E62525", "name": "Venus Red" },
        { "hex": "#5C072B", "name": "Zyclam Red Pearl Effect" },
        { "hex": "#EF4D0E", "name": "Continental Orange" },
        { "hex": "#C96021", "name": "Copper" },
        { "hex": "#FF8C2F", "name": "Gulf Orange" },
        { "hex": "#FF4200", "name": "Lava Orange" },
        { "hex": "#F4650F", "name": "Nepal  Orange" },
        { "hex": "#EE7A3B", "name": "Orange" },
        { "hex": "#DC551B", "name": "Orange (356)" },
        { "hex": "#FF6000", "name": "Orange Red" },
        { "hex": "#F45E00", "name": "Papaya" },
        { "hex": "#FF9626", "name": "Pastel Orange" },
        { "hex": "#B8725F", "name": "Salmon" },
        { "hex": "#FF8A00", "name": "Signal Orange" },
        { "hex": "#9F2504", "name": "Arancio Ishtar Orange" },
        { "hex": "#FF9E3F", "name": "USA Orange" },
        { "hex": "#FF5F27", "name": "Tangerine" },
        { "hex": "#D4EC53", "name": "Acid Green" },
        { "hex": "#0A373C", "name": "Amazon Green" },
        { "hex": "#A1D433", "name": "Apple Green (Daphne Green)" },
        { "hex": "#51E051", "name": "Ascot (Shamrock) Green" },
        { "hex": "#7FC1A1", "name": "Auratium Green" },
        { "hex": "#3D4C45", "name": "Aventura (Aventurine) Green" },
        { "hex": "#3ACAC8", "name": "Beryll" },
        { "hex": "#DBFF4D", "name": "Birch Green" },
        { "hex": "#3F4131", "name": "Black Olive" },
        { "hex": "#08361D", "name": "Brewster Green" },
        { "hex": "#03520D", "name": "British Racing Green" },
        { "hex": "#699F5E", "name": "Bush (Leaf) Green" },
        { "hex": "#E3F0DC", "name": "Colibri Green" },
        { "hex": "#18A467", "name": "Conda Green" },
        { "hex": "#0D4820", "name": "Connaught Green" },
        { "hex": "#91A499", "name": "Crystal Green (Modern)" },
        { "hex": "#91A499", "name": "Crystal Green (Vintage)" },
        { "hex": "#382F14", "name": "Dark Olive" },
        { "hex": "#A2BC51", "name": "Delphi Green" },
        { "hex": "#319B3B", "name": "Emerald Green" },
        { "hex": "#42C098", "name": "Fern Green" },
        { "hex": "#024642", "name": "Fjord Green" },
        { "hex": "#093B1F", "name": "Forest Green" },
        { "hex": "#C1CF49", "name": "Golden Green" },
        { "hex": "#0B3C06", "name": "Goodwood Green" },
        { "hex": "#A9B3AE", "name": "Granite Green" },
        { "hex": "#5ED58D", "name": "Green" },
        { "hex": "#20C12D", "name": "GT/RS Green" },
        { "hex": "#D0DCD9", "name": "Ice (Silver) Green" },
        { "hex": "#BED7C8", "name": "Inari Silver" },
        { "hex": "#0A430F", "name": "Irish Green" },
        { "hex": "#5DE6BE", "name": "Jade Green" },
        { "hex": "#2A8E33", "name": "Java Green" },
        { "hex": "#359154", "name": "Jet Green" },
        { "hex": "#163A36", "name": "Lago Green (Dark Teal)" },
        { "hex": "#A6C9CA", "name": "Lagoon Green" },
        { "hex": "#54756D", "name": "Lhasa Green" },
        { "hex": "#8BCC45", "name": "Light Green" },
        { "hex": "#364A38", "name": "Light Oak Green" },
        { "hex": "#139E55", "name": "Lighter Green" },
        { "hex": "#88E816", "name": "Lime (Birch) Green" },
        { "hex": "#E0F037", "name": "Linden Green (Chartreuse)" },
        { "hex": "#7EE410", "name": "Lizard Green" },
        { "hex": "#39483C", "name": "Malachite Green" },
        { "hex": "#24B130", "name": "Mamba Green" },
        { "hex": "#0D3A0A", "name": "Dark Green" },
        { "hex": "#93FDEA", "name": "Mint Green" },
        { "hex": "#6EA687", "name": "Mint Green (Dark)" },
        { "hex": "#0E4210", "name": "Moss Green" },
        { "hex": "#14747D", "name": "Murano Green" },
        { "hex": "#80AA00", "name": "NATO Green" },
        { "hex": "#2B4A05", "name": "Natoolive" },
        { "hex": "#1D391A", "name": "Nile Green" },
        { "hex": "#354829", "name": "Oak Green" },
        { "hex": "#0A99A3", "name": "Ocean Jade" },
        { "hex": "#CCB535", "name": "Olive" },
        { "hex": "#80921F", "name": "Olive Green" },
        { "hex": "#385046", "name": "Onyx Green" },
        { "hex": "#237635", "name": "Palm Green" },
        { "hex": "#5EF05E", "name": "Palma Green" },
        { "hex": "#C1DF87", "name": "Peridot" },
        { "hex": "#023122", "name": "Pine Green" },
        { "hex": "#004E04", "name": "Porsche Racing Green" },
        { "hex": "#209E22", "name": "Pure Green" },
        { "hex": "#268C43", "name": "Python Green" },
        { "hex": "#9EDF73", "name": "Python Green Chromaflair" },
        { "hex": "#83B9AB", "name": "Racing Green" },
        { "hex": "#BBD1CA", "name": "Radium Green" },
        { "hex": "#043D28", "name": "Rainforest (Jungle) Green" },
        { "hex": "#B1C845", "name": "Ravenna Green" },
        { "hex": "#D4DCB5", "name": "Reseda Green" },
        { "hex": "#B9CBC4", "name": "Rock Green" },
        { "hex": "#1A5E1E", "name": "Rolex Green" },
        { "hex": "#C0DDC1", "name": "Sea Green" },
        { "hex": "#47CB7C", "name": "Signal Green" },
        { "hex": "#363E37", "name": "89 Avalon Green" },
        { "hex": "#2D5433", "name": "Barnato Green" },
        { "hex": "#323633", "name": "Camouflage Green" },
        { "hex": "#2E3430", "name": "Cedar Green" },
        { "hex": "#D0E4C7", "name": "Conifer Green" },
        { "hex": "#114312", "name": "Deep Green" },
        { "hex": "#9DB8A0", "name": "Highland Green" },
        { "hex": "#D6E2D7", "name": "Silver Green" },
        { "hex": "#0A361F", "name": "Tannen Green" },
        { "hex": "#1BB2A4", "name": "Velvet Green" },
        { "hex": "#59C5A0", "name": "Smyrna Green" },
        { "hex": "#2D8092", "name": "Tourmaline (Turmalin) Green" },
        { "hex": "#56CFA9", "name": "Turkey Green" },
        { "hex": "#56B88E", "name": "Turquoise Green" },
        { "hex": "#236D88", "name": "Turquoise" },
        { "hex": "#19580D", "name": "Underberg Green" },
        { "hex": "#4BDB59", "name": "Viper Green" },
        { "hex": "#8CC757", "name": "Willow Green" },
        { "hex": "#5CA190", "name": "Wimbledon Green" },
        { "hex": "#1D8550", "name": "Zambezi (Forest) Green" },
        { "hex": "#F2A501", "name": "Bahama Yellow" },
        { "hex": "#D7D532", "name": "Berber Yellow" },
        { "hex": "#F5EAB7", "name": "Champagne Yellow" },
        { "hex": "#F5F20C", "name": "Chrome Yellow" },
        { "hex": "#EDEDA9", "name": "Condor Yellow" },
        { "hex": "#FFF332", "name": "Fayence Yellow" },
        { "hex": "#FBE746", "name": "Ferrari Yellow" },
        { "hex": "#E7B01A", "name": "Golden Yellow" },
        { "hex": "#4CB811", "name": "Green Yellow" },
        { "hex": "#FCA722", "name": "Atacama Yellow" },
        { "hex": "#E7E930", "name": "Jonquil Yellow" },
        { "hex": "#E6DE0C", "name": "Yellow Matte" },
        { "hex": "#D7C317", "name": "Imola Yellow" },
        { "hex": "#FEF56A", "name": "Lemon (Canary) Yellow" },
        { "hex": "#F7FF9E", "name": "Light Yellow" },
        { "hex": "#F9FFC9", "name": "Pale Yellow" },
        { "hex": "#F8EFCE", "name": "Pasadena Yellow" },
        { "hex": "#FFF4A7", "name": "Pastel Yellow" },
        { "hex": "#F4F100", "name": "Racing Yellow" },
        { "hex": "#ECD438", "name": "Rally Yellow" },
        { "hex": "#DFD942", "name": "Saffron Yellow" },
        { "hex": "#FFD053", "name": "Sand Yellow" },
        { "hex": "#EEFB93", "name": "Saturn Yellow" },
        { "hex": "#c0e116", "name": "Shocking Yellow" },
        { "hex": "#FFC601", "name": "Signal Yellow" },
        { "hex": "#FFDE00", "name": "Speed Yellow" },
        { "hex": "#EDD932", "name": "Summer Yellow (Early)" },
        { "hex": "#E7F667", "name": "Summer Yellow (Late)" },
        { "hex": "#EFCB50", "name": "Sunflower Yellow" },
        { "hex": "#FFD955", "name": "Talbot Yellow" },
        { "hex": "#240606", "name": "Basalt Black" },
        { "hex": "#000000", "name": "Black" },
        { "hex": "#0E0101", "name": "Brilliant Black" },
        { "hex": "#262525", "name": "Carbon Black" },
        { "hex": "#252525", "name": "Diamond Black" },
        { "hex": "#211B1B", "name": "Jet Black" },
        { "hex": "#030301", "name": "LE Bumble Bee" },
        { "hex": "#1B1717", "name": "Montego Black" },
        { "hex": "#454545", "name": "Panther Black" },
        { "hex": "#373737", "name": "Panthero" },
        { "hex": "#060000", "name": "Rallye Black" },
        { "hex": "#000000", "name": "Satin Black" },
        { "hex": "#F6F6F6", "name": "Alpine White" },
        { "hex": "#F9F7F7", "name": "Biarritz White" },
        { "hex": "#EAEAEA", "name": "Carrara White" },
        { "hex": "#F0EFE3", "name": "Chiffon White" },
        { "hex": "#F4F4F0", "name": "Creme White" },
        { "hex": "#F9F9F9", "name": "Glacier White (Modern)" },
        { "hex": "#D5E4BE", "name": "Glacier White (Vintage)" },
        { "hex": "#F7F7F7", "name": "Glacier White" },
        { "hex": "#FBFFFF", "name": "Grand Prix White" },
        { "hex": "#E2E2D7", "name": "Ivory" },
        { "hex": "#FDF9D4", "name": "LE Creamsicle" },
        { "hex": "#F0F0F0", "name": "Light Ivory" },
        { "hex": "#F1F2E5", "name": "Medium Ivory" },
        { "hex": "#F2F2F2", "name": "Oryx White Pearl" },
        { "hex": "#F2F2EE", "name": "Pearl White" },
        { "hex": "#F1F5F6", "name": "Polar White" },
        { "hex": "#FFFFFF", "name": "Pure White" },
        { "hex": "#F6F4F4", "name": "Sand White" },
        { "hex": "#C6C6C5", "name": "Colorado Beige" },
        { "hex": "#A5A5A5", "name": "Diamond Beige" },
        { "hex": "#F6EAA3", "name": "Elfenbeing" },
        { "hex": "#FFF9E4", "name": "Harvest Moon Beige" },
        { "hex": "#E3CC88", "name": "Havana" },
        { "hex": "#EDE199", "name": "Sand Beige" },
        { "hex": "#D1CEB9", "name": "Siam Beige" },
        { "hex": "#D5B142", "name": "African Queen Gold" },
        { "hex": "#58534B", "name": "89 Soho Brown" },
        { "hex": "#4D3A0E", "name": "Argus Brown" },
        { "hex": "#3C3222", "name": "Beluga Brown" },
        { "hex": "#433011", "name": "Chestnut" },
        { "hex": "#655B42", "name": "Havana Brown" },
        { "hex": "#523809", "name": "Ipanema Brown" },
        { "hex": "#412E1B", "name": "Java Brown" },
        { "hex": "#4B341C", "name": "Roman Bronze" },
        { "hex": "#893E36", "name": "Saturn" },
        { "hex": "#B67B47", "name": "Sepia" },
        { "hex": "#3F1503", "name": "Seville Red" },
        { "hex": "#513C06", "name": "Teak Brown" },
        { "hex": "#D5C892", "name": "Toffee Brown" },
        { "hex": "#CECCCC", "name": "89 Tornado Grey" },
        { "hex": "#DADDDD", "name": "Cloud Grey" },
        { "hex": "#B7B7B7", "name": "Dust Grey" },
        { "hex": "#717171", "name": "Felsen Gruen" },
        { "hex": "#E4E4E4", "name": "Fortuna Grey" },
        { "hex": "#ECEFEF", "name": "Light Grey" },
        { "hex": "#CACACA", "name": "Light Oxford Grey" },
        { "hex": "#616161", "name": "Parliament Grey" },
        { "hex": "#B2B2B2", "name": "Pebble Grey" },
        { "hex": "#F6F5F5", "name": "Savoy Grey" },
        { "hex": "#D4D4D4", "name": "Suzuka Grey" },
        { "hex": "#D6D6D6", "name": "Avus Silver" },
        { "hex": "#6C8FBA", "name": "Bentley Silver Lake" },
        { "hex": "#C4D3E4", "name": "Blue Silver" },
        { "hex": "#EEEBEB", "name": "Crystal" },
        { "hex": "#B7B7B7", "name": "Cuvée Silver" },
        { "hex": "#D8EAEB", "name": "Iceland Silver" },
        { "hex": "#E1DFDF", "name": "Light Silver" },
        { "hex": "#B3B3B3", "name": "Silver Grey" },
        { "hex": "#E69E03", "name": "Aurum" },
        { "hex": "#E9D6BF", "name": "Salmon Silver" },
        { "hex": "#342424", "name": "Cherry Black" },
        { "hex": "#3E3E3E", "name": "Havana Black" },
        { "hex": "#060000", "name": "Imperial Black" },
        { "hex": "#383838", "name": "Mamba Black" },
        { "hex": "#03090E", "name": "Marine Black" },
        { "hex": "#2C0101", "name": "Shiraz Red" },
        { "hex": "#EAEAEA", "name": "Grey White" },
        { "hex": "#F0EFE9", "name": "Onyx White Tricoat" },
        { "hex": "#BE5E2F", "name": "Bentley Sunset" },
        { "hex": "#F0EEEE", "name": "Sonora" }
    ]
}